import {createRoot, render, createElement} from '@wordpress/element'
import HeaderNavBar from './components/HeaderNavBar'
import HeaderNavBarMobile from './components/HeaderNavBarMobile'
import SlideBanner from './components/SlideBanner'
import FaqBlock from './components/FaqBlock'
import TeamBlock from './components/TeamBlock'
import TeamBlockNoTablist from './components/Teamblocknotablist'
import EventBlock from './components/EventBlock'
import Carousel from './components/Carousel'
import {BaseProps} from './types'
import LibraryTab from './components/LibraryTab'
import ReactDOM from 'react-dom'
import SchoolMap from './components/SchoolMap'
import AnimationNumber from './components/AnimationNumber'
import Certificate from './components/Certificate'
import LanguageSwitcher from "./components/LanguageSwitcher";
import SearchBlock from "./components/SearchBlock";

function getProps(container: HTMLElement) {
  const dataset = container.dataset || {}
  const dataId = dataset.id

  let data = Object.assign({}, dataset)

  if (dataId) {
    const dom = document.getElementById(dataId)
    if (dom) {
      try {
        data = JSON.parse(dom.textContent)
      } catch (e) {
        console.warn(e)
      }
    }
  }

  const props: BaseProps = Object.assign({
    className: container.className,
    dom: container,
    id: container.dataset.id,
    data
  })

  props.children = container.innerHTML
  return props
}

function getComponent(container: HTMLElement) {
  const classList = container.classList

  switch (true) {
    case classList.contains('wp-block-rocket-navbar'):
      return HeaderNavBar
    case classList.contains('wp-block-rocket-navbar-mobile'):
      return HeaderNavBarMobile
    case classList.contains('wp-block-rocket-banner'):
      return SlideBanner
    case classList.contains('wp-block-rocket-faq'):
      return FaqBlock
    case classList.contains('wp-block-rocket-team'):
      return TeamBlock
    case classList.contains('wp-block-rocket-team-no-tablist'):
      return TeamBlockNoTablist
    case classList.contains('wp-block-rocket-events'):
      return EventBlock
    case classList.contains('wp-block-rocket-carousel'):
      return Carousel
    case classList.contains('wp-block-rocket-library-tab'):
      return LibraryTab
    case classList.contains('wp-block-rocket-school-map'):
      return SchoolMap
    case classList.contains('wp-block-rocket-animation-number'):
      return AnimationNumber
    case classList.contains('wp-block-rocket-certs'):
      return Certificate
    case classList.contains('wp-block-rocket-language-switcher'):
      return LanguageSwitcher
    case classList.contains('wp-block-rocket-search'):
      return SearchBlock
  }

  return (props: any) => <div className={props.className} dangerouslySetInnerHTML={{ __html: props.children }}></div>
}

export default function loader(container: HTMLElement) {
  const props: BaseProps = getProps(container)
  const Component = getComponent(container)

  if (ReactDOM.version.startsWith('18')) {
    const root = createRoot(container)
    root.render(<Component {...props} />)
  } else {
    render(<Component {...props} />, container)
  }
}